var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHashtag = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.124 3.008A1 1 0 0 1 18 4.02l-.008.103L17.632 7H20a1 1 0 1 1 0 2h-2.617l-.75 6H20a1 1 0 1 1 0 2h-3.617l-.39 3.124A1 1 0 0 1 14 19.979l.008-.103.36-2.876H8.382l-.39 3.124A1 1 0 0 1 6 19.979l.008-.103.36-2.876H4a1 1 0 1 1 0-2h2.617l.75-6H4a1 1 0 0 1 0-2h3.617l.39-3.124.018-.1A1 1 0 0 1 10 4.02l-.008.103L9.632 7h5.985l.39-3.124.018-.1a1 1 0 0 1 1.099-.768ZM8.633 15h5.984l.75-6H9.383l-.75 6Z"
})));
SvgHashtag.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgHashtag);
export default ForwardRef;